import { PatchPsychosocialSurveyResponseDTO } from '@/core/dto/psychosocial-report';
import type { PatchPsychosocialSurveyResponse } from '@/types/Psychosocial';

export class PatchSurveyMapper {
	constructor(private readonly data: PatchPsychosocialSurveyResponseDTO) {}

	toDomain(): PatchPsychosocialSurveyResponse {
		return this.data;
	}
}
